import { Component, Input } from "@angular/core";
import { AuthService } from "src/app/share/service/auth.service";
import { UserService } from "src/app/share/service/user.service";
import { DrawerService } from "../../share/service/drawer.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { PartnerService } from "src/app/share/service/partner.service";
import { PARTNER_INFO } from "src/app/share/constants/partner.constants";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class AppHeaderComponent {
	@Input() showMenu: boolean = true;
	partnerCode: string = "";
	logoLink: string = "";
	isShowWhatsapp: boolean = true;

	constructor(
		private router: Router,
		public drawerService: DrawerService,
		public userService: UserService,
		public authService: AuthService,
		public translate: TranslateService,
		private partnerService: PartnerService
	) {
		/* Handle for Partners */
		this.partnerCode = this.partnerService.getPartnerCode();

		if(!this.partnerCode) {
			this.partnerCode = "ps";
		} 
		this.getPartnerInfo(this.partnerCode);
	}

	switchLanguage(lang: string) {
		this.translate.use(lang);
	}

	whatsappRedirect() {
		const defaultWhatsAppNumber = 60182822320; // Default fallback number
		const lang = this.translate.currentLang === "en" ? "en" : "ms";
		const whatsappContent = lang === "ms" ? "" : "";
	
		// Retrieve partner details
		const partner = PARTNER_INFO[this.partnerCode];
	
		// Determine which number to use
		const whatsappNumber =
			partner?.whatsapp?.isDisplay && partner.whatsapp.value
				? partner.whatsapp.value
				: defaultWhatsAppNumber;
	
		const url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
			whatsappContent
		)}&source=&data=&app_absent=&lang=${lang}`;
	
		window.open(url, "_blank");
	}

	private getPartnerInfo(partnerCode) {
		if(partnerCode == "ps"){
			this.logoLink =`/assets/image/partner/dr-logo.png`;
		} else {
			this.logoLink =`/assets/image/partner/${partnerCode}-dr-logo.png`;
			this.isShowWhatsapp = PARTNER_INFO[partnerCode].whatsapp.isDisplay;
		}
	}

	goToDefault() {
		if(!this.partnerCode || this.partnerCode == 'ps'){
			window.location.href = "/login";
		} else {
			window.location.href = "/login?partnerCode=" + this.partnerCode;
		}
	}
}
